import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthGuard } from './auth.guard';
import { MsalGuard } from '@azure/msal-angular';

export const DynamicAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const isFakeLogin = localStorage.getItem('isFakeLogin') === 'true';
  if (isFakeLogin) {
    return inject(AuthGuard).canActivate();
  } else {
    //return inject(MsalGuard).canActivate(route, state);
    return inject(AuthGuard).canActivate();
  }
};